import { defineStore } from "pinia";
import { UserSessionEntityType } from "~/modules/user/models/UserSessionEntityType.enum";
import { useUserSession } from "~/modules/user/stores/useUserSession";

// Interface for current selected organization
interface CurrentOrganization {
  code: number;
  name: string;
  useExternalIdp?: boolean;
}

export const useOrganizationStore = defineStore("OrganizationStore", () => {
  const { userSession } = useUserSession();

  // Initialize the current organization with the user session one.
  const currentOrganization: Ref<CurrentOrganization | undefined> = ref();

  if (
    userSession &&
    (userSession.entity.type === UserSessionEntityType.OPERATOR ||
      userSession.entity.type === UserSessionEntityType.ADMINISTRATION)
  ) {
    currentOrganization.value = {
      code: userSession.entity.code,
      name: userSession.entity.name,
      useExternalIdp: userSession.entity.useExternalIdp,
    };
  }

  /**
   * Set the current selected organization
   * @param organization
   */
  function setCurrentOrganization(organization: CurrentOrganization) {
    currentOrganization.value = organization;
  }

  return {
    currentOrganization,
    setCurrentOrganization,
  };
});
